import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

// import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import ConfigModule from "@/store/modules/ConfigModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import ExAuthModule from "@/exstore/ExAuthModule";
import ExSepetModule from "@/exstore/ExSepetModule";
import ExNotificationsModule from "@/exstore/ExNotificationsModule";

config.rawError = true;

const store = createStore({
  modules: {
    ExSepetModule,
    ExAuthModule,
    BodyModule,
    ExNotificationsModule,
    ConfigModule,
    ThemeModeModule,
  },
});

export default store;
